module.exports = __webpack_public_path__ + "media/images/flags/4x3/sgp-12919d6222c2390520d5edd5dc0510d9.svg";